<script>
  /**
   * SelectHeaderCell — the select-all checkbox in the `Table` header, shown in
   * list view during asset selection mode.
   *
   * Scoped to the rows it is given (the filtered set), never the whole library.
   * Checked only when every visible row is selected; a partial selection reads
   * as unchecked, and clicking from there selects the remainder.
   *
   * The page must rebuild the column reactively so `props.rows` tracks the
   * filtered rows — `Table` reads `col.title.props` on render, not on a subscription.
   *
   * @example
   * $: selectColumn = {
   *   key: 'select',
   *   title: { component: SelectHeaderCell, props: { selection, rows: filtered } },
   *   value: () => '',
   *   renderComponent: { component: SelectCell, props: { selection } },
   *   headerClass: 'select-cell'
   * };
   */

  import { format } from 'svelte-i18n';

  /**
   * Column props from the column definition. Must contain `selection`, and
   * `rows` for the currently visible rows.
   * @type {{ selection: Object, rows: Object[] }}
   */
  export let props = {};

  const { selection } = props;

  const onToggleAll = () => {
    if (allSelected) {
      selection.clear();
      return;
    }

    selection.selectAll(rows);
  };

  $: rows = props.rows ?? [];
  $: count = $selection.size;
  $: allSelected = rows.length > 0 && count === rows.length;
</script>

<input
  class="form-check-input"
  type="checkbox"
  checked={allSelected}
  on:click|stopPropagation
  on:change={onToggleAll}
  aria-label={$format('label.SELECT_ALL')}
/>
